/*
 * @Author: Teemo Ding
 * @Date: 2021-08-13 09:52:27
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-02-03 09:27:14
 * @FilePath: /unifyxp-v2-store-portal/src/pages/CustomerDatabaseConfig/Components/AccountInviteModal/index.tsx
 */

import { useRequest } from 'ahooks';
import { Form, message } from 'antd';
import _ from 'lodash';
import React, { Fragment, useState } from 'react';
//import { CommunicationCategory } from '@/src/types/common/template';
import {
  Checkbox,
  Input,
  Label,
  ModalFooter,
  Select,
} from '@/src/components/Antd';
import Configuration from '@/src/components/Configuration/Configuration';
import SelectObjectAsValue from '@/src/components/SelectObjectAsValue';
import { getAllTemplates } from '@/src/request/common';
import {
  request_allSalesChannels,
  request_sendInvitation,
} from '@/src/request/customer/customerDetail';
import { useParams } from 'react-router';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';
import { getAreaCodes } from 'src/constrains/GlobalProvider/slice';
import { useSelector } from 'react-redux';
import { EnumFieldType } from 'src/types/common/customerDb';

const AddComment = ({ onCancel, information, reloadData }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [form] = Form.useForm();
  const params: any = useParams();
  const [domain, setDomain] = useState([]);
  const { customerDatabaseUuid, customerUuid } = params;
  const areaCodes = useSelector(getAreaCodes());

  const informationData = information
    .filter(
      (item) =>
        (_.get(item, 'field.fieldType', '') == EnumFieldType.Email &&
          _.get(item, 'value[0]', '')) ||
        (_.get(item, 'field.fieldType', '') ==
          EnumFieldType.AreaCodeMobileNumber &&
          _.get(item, 'value[1]', '')),
    )
    .map((item) => {
      if (
        _.get(item, 'field.fieldType', '') == EnumFieldType.AreaCodeMobileNumber
      ) {
        const areaCodeUuid = _.get(item, 'value[0]', '');
        const phNo = _.get(item, 'value[1]', '');
        const areaCode = _.get(
          areaCodes.find((i) => i.uuid === areaCodeUuid),
          'areaCode',
        );
        return { ...item, value: [`+${areaCode}`, phNo] };
      } else {
        return item;
      }
    });

  const { data: { emailTemplates = [], smsTemplates = [] } = {} } = useRequest(
    () => getAllTemplates('AccountInvitation', ''),
  );
  useRequest(() => request_allSalesChannels(customerDatabaseUuid), {
    onSuccess: (domain) => {
      const domainOptions = domain.map((item) => ({
        value: item.uuid,
        label: item.name,
      }));
      setDomain(domainOptions);
    },
  });

  const option = informationData.map((item) => ({
    type: _.get(item, 'field.fieldType', ''),
    value: _.get(item, 'value', '').join(' '),
    label:
      _.get(item, 'field.name', '') +
      '(' +
      _.get(item, 'value', []).toString() +
      ')',
  }));
  const templateOptions = (templates) =>
    (templates || []).map((item) => {
      return {
        value: item.uuid,
        label: item.name,
      };
    });

  const handleSubmit = (values) => {
    values.customerUuid = customerUuid;
    values.customerDBUuid = customerDatabaseUuid;
    values.email = values.sendTo.type == 'Email' ? values.sendTo.value[0] : '';
    values.areaCode =
      values.sendTo.type == 'AreaCodeMobileNumber'
        ? values.sendTo.value.split(',')[0]
        : '';
    values.mobile =
      values.sendTo.type == 'AreaCodeMobileNumber'
        ? values.sendTo.value.split(',')[1]
        : '';
    request_sendInvitation(values).then(() => {
      message.success(
        getI18n('customerDatabaseSetting.customerDatabaseSettings.save_succ'),
      );
      onCancel();
      reloadData(['Invite', 'TimeLine']);
    });
  };

  return (
    <div className={`${css.customerDatabaseModal} ${css.container}`}>
      <Form
        form={form}
        initialValues={{ sendTo: option[0] }}
        onFinish={handleSubmit}>
        <Form.Item
          name='sendTo'
          label={
            <Label title={getI18n('customerList.accountInviteModal.sendto')} />
          }
          labelCol={{ span: 24 }}>
          <SelectObjectAsValue
            objectAsValue
            labelKey={'label'}
            valueKey={'value'}
            options={option}
            size='large'
            notFoundContent={getI18n(
              'customerList.accountInviteModal.notFoundContent',
            )}></SelectObjectAsValue>
        </Form.Item>
        <Form.Item
          noStyle
          shouldUpdate={(prevValues, curValues) => {
            return (
              prevValues.sendBccTo !== curValues.sendBccTo ||
              prevValues.sendTo !== curValues.sendTo
            );
          }}>
          {({ getFieldValue }: any) =>
            getFieldValue('sendTo').type == 'Email' && (
              <Fragment>
                <Form.Item noStyle name='sendBccTo' valuePropName='checked'>
                  <Checkbox>
                    {getI18n('customerList.accountInviteModal.sendBccTo')}
                  </Checkbox>
                </Form.Item>
                {getFieldValue('sendBccTo') && (
                  <Form.Item
                    label={
                      <Label
                        bottomTitle={getI18n(
                          'customerList.accountInviteModal.bootomtitle',
                        )}
                      />
                    }
                    rules={[
                      {
                        required: true,
                        message: getI18n(
                          'customerList.accountInviteModal.pleaseinputemailaddress',
                        ),
                      },
                    ]}
                    name='bcc'
                    labelCol={{ span: 24 }}>
                    <Input
                      size='large'
                      placeholder={getI18n(
                        'customerList.accountInviteModal.pleaseinputemailaddress',
                      )}
                    />
                  </Form.Item>
                )}
              </Fragment>
            )
          }
        </Form.Item>
        <Form.Item
          noStyle
          shouldUpdate={(prevValues, curValues) => {
            return prevValues.sendTo !== curValues.sendTo;
          }}>
          {({ getFieldValue }: any) => (
            <Form.Item
              label={
                <Label
                  title={
                    getFieldValue('sendTo').type == 'Email'
                      ? getI18n('customerList.accountInviteModal.emailTemplate')
                      : getI18n(
                          'customerList.accountInviteModal.messageTemplate',
                        )
                  }
                />
              }
              name={
                getFieldValue('sendTo').type == 'Email'
                  ? 'emailTemplateUuid'
                  : 'mobileTemplateUuid'
              }
              labelCol={{ span: 24 }}>
              <Select
                size='large'
                options={templateOptions(
                  getFieldValue('sendTo').type == 'Email'
                    ? emailTemplates
                    : smsTemplates,
                )}
              />
            </Form.Item>
          )}
        </Form.Item>
        <Form.Item
          label={
            <Label
              title={getI18n(
                'customerList.accountInviteModal.selectSalesChannel',
              )}
            />
          }
          name='salesChannelUuid'
          labelCol={{ span: 24 }}>
          <Select
            size='large'
            options={domain}
            notFoundContent={getI18n(
              'customerList.accountInviteModal.nosaleschannel',
            )}
          />
        </Form.Item>
      </Form>
      <div className={css.configuration}>
        <Configuration
          configStart={getI18n(
            'customerList.accountInviteModal.thistemplatecanbeeditedin',
          )}
          hideGt
          configLink={getI18n('customerList.accountInviteModal.communication')}
          linkTo='/'
          configEnd=' '
        />
      </div>
      <ModalFooter
        onOk={() => form.submit()}
        onText={getI18n('general.confirm')}
        onCancel={onCancel}
      />
    </div>
  );
};

export default AddComment;
